import client from 'core/axios';
import handleError from 'core/axios/handleError';
import {
  handleJSONResponse,
  handleFileResponse,
} from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getScenario = ({ scenarioUuid, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/life-simulator/scenario/${scenarioUuid}`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getContext = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/life-simulator/scenario/context/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateScenario = ({
  version = 'v1',
  scenarioUuid,
  payload,
} = {}) =>
  client
    .request({
      url: `${version}/life-simulator/scenario/${scenarioUuid}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteScenario = ({ version = 'v1', scenarioUuid } = {}) =>
  client
    .request({
      url: `${version}/life-simulator/scenario/${scenarioUuid}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const downloadScenarioReport = ({ version = 'v1', scenarioUuid }) =>
  client
    .request({
      url: `${version}/life-simulator/scenario/${scenarioUuid}/pdf-report/`,
      method: RequestMethod.GET,
      responseType: 'blob',
    })
    .then(handleFileResponse)
    .catch(handleError);

export const getCounties = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/life-simulator/county/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
